import { render, staticRenderFns } from "./ProcessametoDeRepassesEmpresas.vue?vue&type=template&id=939c7a66&"
import script from "./ProcessametoDeRepassesEmpresas.vue?vue&type=script&lang=js&"
export * from "./ProcessametoDeRepassesEmpresas.vue?vue&type=script&lang=js&"
import style0 from "./ProcessametoDeRepassesEmpresas.vue?vue&type=style&index=0&id=939c7a66&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports